/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Link } from "gatsby";
import BrakesInString from './BrakesInString'
import CustomLink from './CustomLink'

const AnchoredPageNavItems = (props) => {

  return (
    <div className={`nosql__items nosql__items--cols-${props.cols}`}>
      {props.items && props.items.length > 0 && (
        <>
          {props.items.map( (item, index) => {
            switch (item.linkType) {
              case "internal": return (
                  <div className="nosql__item" data={item.caption} key={index}>
                  <div className="nosql__item-icon" onClick={() => window.scrollTo({
                    top: document.getElementById(`${item.slug}`) ? document.getElementById(`${item.slug}`).offsetTop - 100 : 0,
                    behavior: "smooth"
                  })}>
                    <img src={item.image} alt={item.imageAlt}/>
                    {item.soon && item.soon === true && (
                        <div className="databases-table__item-soon"></div>
                    )}
                  </div>
                  <div className="nosql__item-title">
                    <span onClick={ () => window.scrollTo({
                      top: document.getElementById(`${item.slug}`) ? document.getElementById(`${item.slug}`).offsetTop - 100 : 0,
                      behavior: "smooth"
                    }) }><BrakesInString text={item.caption} /></span>
                  </div>
                </div>);
              case "external": return (
                  <div className="nosql__item" data={item.caption} key={index}>
                    <CustomLink
                        className="nosql__item--external"
                        linkType={item.linkType}
                        linkURL={item.slug}
                    >
                      <div className="nosql__item-icon">
                        <img src={item.image} alt={item.imageAlt}/>
                        {item.soon && item.soon === true && (
                            <div className="databases-table__item-soon"></div>
                        )}
                      </div>
                      <div className="nosql__item-title">
                        <span><BrakesInString text={item.caption} /></span>
                      </div>
                    </CustomLink>

                  </div>
              );
              case "relative": return (
                  <div className="nosql__item" data={item.caption} key={index}>
                    <Link
                        className="nosql__item--external"
                        to={item.slug}
                    >
                      <div className="nosql__item-icon">
                        <img src={item.image} alt={item.imageAlt}/>
                        {item.soon && item.soon === true && (
                            <div className="databases-table__item-soon"></div>
                        )}
                      </div>
                      <div className="nosql__item-title">
                        <span><BrakesInString text={item.caption} /></span>
                      </div>
                    </Link>

                  </div>
              );
              default: return (
                  <div className="nosql__item" data={item.caption} key={index}>
                    <div className="nosql__item-icon" onClick={() => window.scrollTo({
                      top: document.getElementById(`${item.slug}`) ? document.getElementById(`${item.slug}`).offsetTop - 100 : 0,
                      behavior: "smooth"
                    })}>
                      <img src={item.image} alt={item.imageAlt}/>
                      {item.soon && item.soon === true && (
                          <div className="databases-table__item-soon"></div>
                      )}
                    </div>
                    <div className="nosql__item-title">
                    <span onClick={ () => window.scrollTo({
                      top: document.getElementById(`${item.slug}`) ? document.getElementById(`${item.slug}`).offsetTop - 100 : 0,
                      behavior: "smooth"
                    }) }><BrakesInString text={item.caption} /></span>
                    </div>
                  </div>);
            }

          })}
        </>
      )}

    </div>
  );
};

export default AnchoredPageNavItems;